import { Injectable } from '@angular/core'
import { IArrayMap } from '@adex/shared/models/array-map'
import { IDataConverter } from '@adex/shared/models/data-converter'
import { urls } from '@adex/shared/network/urls'
import { StubConverter } from './stub.converter'
import { NotificationListConverter } from './notification-list.converter'
import { NotificationConverter } from '@adex/shared/network/converters/notification.converter'


@Injectable({ providedIn: 'root' })
export class DataConvertersManager {
  private readonly converters: IArrayMap<IDataConverter<any, any>> = {
    [urls.notifications.list]: this.notificationsListConverter,
    [urls.notifications.create]: this.notificationConverter,
    [urls.notifications.update]: this.notificationConverter
  }

  constructor(
    private readonly stubConverter: StubConverter<any>,
    private readonly notificationConverter: NotificationConverter,
    private readonly notificationsListConverter: NotificationListConverter
  ) {
  }

  public getConverter<Dto, Model>(url: string): IDataConverter<Dto, Model> {
    if (this.converters[url]) return this.converters[url]
    return this.stubConverter
  }
}
